import { P02 } from "./ProductSalesSummary/P02"

export const DistributorProductSummary = {
  "sections": [
    P02
  ]
}